import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Çeviri dosyalarını tanımla
const resources = {
  en: {
    translation: {
      title: "en",
      pageTitle: "QR Code Generator",
      downloadPng: "Download PNG",
      downloadSVG: "Download SVG",
      welcome: "Welcome to the application",
      login: "Login",
      register: "Register",
      uploadButtonText: "Upload any file (.jpg, .pdf, .mp3, .docx, .pptx)",
      placeHolderText: "Enter your website or text",
    },
  },
  tr: {
    translation: {
      title: "tr",
      pageTitle: "QR Code Generator",
      downloadPng: "İndir PNG",
      downloadSVG: "İndir SVG",
      welcome: "Uygulamaya hoş geldiniz",
      login: "Giriş",
      register: "Kayıt",
      uploadButtonText:
        "Herhangi bir dosyayı yükleyin (.jpg, .pdf, .mp3, .docx, .pptx)",
      placeHolderText: "Web sitenizi veya metninizi girin",
    },
  },
};

i18n
  .use(LanguageDetector) // Dil tespitini aktif et (tarayıcı dilini algılar)
  .use(initReactI18next) // React ile entegrasyon
  .init({
    resources,
    fallbackLng: "tr", // Dil tespit edilemezse varsayılan dil
    interpolation: {
      escapeValue: false, // React otomatik olarak XSS koruması sağladığı için gereksiz
    },
  });

export default i18n;
